import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "UTCTimeIndicatorWrapper" }
const _hoisted_2 = { class: "UTCTimeIndicator" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
				'UTCTimeMessage',
				{ 'UTCTimeWarning': _ctx.shouldUtcWarningBeShown },
				{ 'UTCTimeError': _ctx.shouldUtcErrorBeShown }
			])
    }, " Please wait for " + _toDisplayString(_ctx.minutesUntilTwelveFifteen) + " minutes, refresh the page, and make your changes. ", 3 /* TEXT, CLASS */),
    _createElementVNode("span", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("strong", null, "UTC Time:", -1 /* CACHED */)),
      _createTextVNode(" " + _toDisplayString(_ctx.utcTime), 1 /* TEXT */)
    ])
  ]))
}